/**
 * The main query param that triggers a local check for the Nibbles Pouches
 * Bundle upsell (i.e., we'll call checkNibblesPouchesUpsellEligibility if
 * present without a more specific override).
 */
export const NIBBLES_POUCHES_UPSELL_QUERY_KEY = "showNibblesPouchesPopUpFromPath";

/**
 * The param used when the server has ALREADY confirmed eligibility and wants
 * to directly tell us whether to show the bundle upsell. If this is present,
 * we skip the local check and trust the server's determination.
 * This should ONLY be set by a server redirect after it has verified eligibility.
 */
export const NIBBLES_POUCHES_UPSELL_OVERRIDE_KEY = "pouchesUpsellType";

/**
 * The param the server uses to pass through which subscription the bundle
 * should be applied to, when NIBBLES_POUCHES_UPSELL_OVERRIDE_KEY is "eligible".
 */
export const NIBBLES_POUCHES_UPSELL_SUBSCRIPTION_ID_KEY = "pouchesSubscriptionId";
